
export default {
  name: 'LandingPageProduct',
  props: {
    product: { type: Object, required: true }
  },
  computed: {
    productOptionsText() {
      if (!this.product.product_options) return null;

      const productOptionValues = Object.values(this.product.product_options);
      if (!productOptionValues.length) return null;

      return this.$t('order.product_options', [
        productOptionValues.join(' ・ ')
      ]);
    }
  }
};
